import './style.css';
import { DropDown, InputField } from '@/components/Exporter';
import { GetCountryLookup, GetNationalitiesLookup } from '@/api/endpoints';
import RedioBtns from '@/components/formFields/RedioBtns';
import SectionWrapper from '../shared/SectionWrapper';

const GENDER_LIST = [
    { label: 'Male', value: 0 },
    { label: 'Female', value: 1 }
]

const BrokerInformation = ({ formHandler }) =>

    <SectionWrapper name="broker-information" icon="streamline-cyber:person" >
        <InputField lang="any" isLoading={false} name="name" formHandler={formHandler} />
        <InputField lang="any" isLoading={false} name="passportNumber" formHandler={formHandler} />
        <RedioBtns className="col-md-6" name="gender" List={GENDER_LIST} formHandler={formHandler} />
        <DropDown isMulti={false} label="nationality" endPoint={GetNationalitiesLookup} formHandler={formHandler} />
        <DropDown isMulti={false} label="countryOfResidence" endPoint={GetCountryLookup} formHandler={formHandler} />
        <InputField lang="any"isLoading={false} name="address" formHandler={formHandler} />
    </SectionWrapper>


export default BrokerInformation;

